import useStuckWatchdog from './useStuckWatchdog';

/**
 * Sits above the /upload client timeout so the watchdog never preempts the real error
 * handling. If it fires at all, the turn died somewhere we haven't accounted for.
 */
export const STUCK_RECORDING_TIMEOUT_MS = 60000;

/**
 * Last-resort recovery for a microphone that never came back.
 *
 * `sharedState.loading` is latched on the moment a recording stops, and the mic button
 * stays disabled until the turn resolves. Every failure path we know about now releases
 * it explicitly, but a path we haven't found still costs the learner their whole session:
 * they see a dead microphone, no error, and no option but a page reload. That is how
 * MAD-788 stranded a learner mid-placement-test five times over.
 *
 * Armed from the recording's own stop handler rather than by watching `loading`, so it
 * only ever guards a real recorded turn — not the other flows that share the flag.
 *
 * @param {object} params
 * @param {boolean} params.loading - The shared loading latch; falling false disarms.
 * @param {(stuckForMs: number) => void} params.onStuck - Called once when the turn never resolved.
 * @returns {() => void} arm - Call from the recording stop handler.
 */
export default function useRecordingWatchdog({ loading, onStuck }) {
  return useStuckWatchdog({
    active: loading,
    timeoutMs: STUCK_RECORDING_TIMEOUT_MS,
    onStuck,
  });
}
